<template>
  <div id="data-list-list-view" class="data-list-container">
    <vx-card title="Overview">
      <p>Create Announcements for students</p>

      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-justify="flex-start" vs-align="center" vs-w="6">
          <div class="demo-alignment">
            <vs-button type="line" line-origin="right" color="primary" @click="openNewMessage = true">New Message</vs-button>
          </div>
        </vs-col>
        <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="6">
          <div class="demo-alignment">
            
          </div>
        </vs-col>
      </vs-row>
    </vx-card>

    <br></br>

    <vx-card title="Announcements">
      <div slot="no-body" class="mt-4">
        <vs-table :data="messages" class="table-dark-inverted stripe">
          <template slot="thead">
            <vs-th>MESSAGE</vs-th>
            <vs-th>DATE</vs-th>
          </template>
          <template ssslot-scope="{messages}">

            <vs-tr v-for="m in messages" :key="m.id">
              <vs-td :data="m.id">
                <vs-col vs-type="flex" xvs-justify="center" vs-align="center" vs-w="10">
                  <div>
                    <small><b>{{ m.subject }}</b></small>
                    <br>
                    <span>{{ m.body }}</span>
                    <br>
                    <small>
                      <span v-if="m.target === 'class'">{{ classes[m.target_id].class_name }}</span>
                      {{ m.target | title }}
                    </small>
                  </div>
                </vs-col>
                <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="2">
                  <vs-button radius color="dark" type="flat" icon-pack="feather" icon="icon-trash-2" v-on:click="openDelConfirm(m.id)"></vs-button>
                </vs-col>
              </vs-td>
              <vs-td :data="m.id">
                <small>{{ m.createdAt | moment("MMM Do, YYYY HH:MM") }}</small>
                <br>
                <small>{{ m.first_name }}</small>
              </vs-td>
            </vs-tr>

          </template>
        </vs-table>
      </div>
    </vx-card>


    <vs-popup class="holamundo" title="New Message" :active.sync="openNewMessage">
      <div class="vx-row mb-6">
      <div class="vx-col w-full">
        <v-select v-model="form.class" :options="options.classes" placeholder="Select Class" class="mb-3"  />
        <vs-input v-model="form.subject" label="Subject" class="w-full mb-5" />
        <vs-textarea v-model="form.message" label="Type Message Here" rows="4" />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button class="mr-3 mb-2" @click="pushMessage">Submit</vs-button>
      </div>
    </div>
    </vs-popup>

  </div>
</template>


<script>
import vSelect from 'vue-select'

export default {
  components: {
    vSelect
  },
  data () {
    return {
      messages: [],
      openNewMessage: false,
      deleteMessageId: null,
      form: {
        message: '',
        class: null,
        subject: ''
      },
      options: {
        classes: [],
        type: [
          {label: 'Students'},
          {label: 'Teachers'},
          {label: 'School'}
        ]
      }
    }
  },
  computed: {
    classes () {
      return this.$store.state.academics.classes
    }
  },
  methods: {
    openDelConfirm (id) {
      this.deleteMessageId = id

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Do you really want to delete this Announcement.',
        accept: this.deleteMessage
      })
    },

    pushMessage () {
      if (!(this.form.class && this.form.class && this.form.subject)) {
        return this.$vs.notify({ color: 'danger', title: 'Missing fields', text: 'Please provide class, subject and message' })
      }

      const payload = {
        body: this.form.message,
        subject: this.form.subject,
        target: 'class',
        target_id: this.form.class.id
      }

      this.$http.post('/lms/st/message', payload).then((response) => {
        if (response && response.data && response.data.data) {
          this.$vs.notify({ color: 'success', title: 'Announcement Sent', text: 'Announcement has been sent successfully' })
          this.openNewMessage = false
          this.fetchMessages()
        }
      }).catch((error) => { 
        console.log(error)
      })
    },

    deleteMessage () {
      this.$http.delete(`/lms/st/message/content/${this.deleteMessageId}`).then((response) => {
        if (response && response.data && response.data.data) {
          this.$vs.notify({ color: 'success', title: 'Announcement Deleted', text: 'Announcement has been deleted successfully' })
        }
        this.fetchMessages()
        this.deleteMessageId = null
      }).catch((error) => { 
        console.log(error)
      })
    },


    fetchMessages () {
      this.$http.get('/lms/st/message').then((response) => {
        if (response && response.data && response.data.data) {
          this.messages = response.data.data
        }
      }).catch((error) => { 
        console.log(error)
      })
    }
  },
  created () {
    this.fetchMessages()

    this.$http.get('/lms/st/academics/subject/assigned').then((response) => {
      const uniqueClass = {}

      if (response && response.data && response.data.data) {
        response.data.data.forEach((v) => {
          console.log(v.class_id, uniqueClass[v.class_id])
          if (!uniqueClass[v.class_id]) {
            this.options.classes.push({ label: v.class_name, id: v.class_id })
          }
          uniqueClass[v.class_id] = 1
        })
      }
    }).catch((error) => { 
      console.log(error)
    })
  },
  mounted () {
    this.isMounted = true
  }
}
</script>

<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>